export const CURRENT_VIDEO_SCHEMA_JSON_LD_ID = 'video-player-schema-json-ld';

export type Video = {
    i: string;
    t: string;
    d: string;
    s: string;
    aid: string;
    cuts: number;
    muts: number;
    puts: number;
    thumb: string;
    poster: string;
    cat: string;
    cats: any[];
    atts: any[];
    lks: Lk[];
    tgs: string[];
    plid: string;
    cutss: string;
    mutss: string;
    putss: string;
}

export type Lk = {
    res: string;
    uri: string;
}

// This funciton dynamically adds the JSON-LD schema structured data - VideoObject
// for the currently playing/loaded video. This will help search engines better understand and index 
// our video content better.
// Reference: 
// 1 - https://developers.google.com/search/docs/appearance/structured-data/video#video-object
// 2 - https://schema.org/VideoObject
// TechDebt: our API doesn't return video duration, so we shall leave that out for now.
export function udpateVideoSchema(videoData: Video): void {
    if (!videoData) {
        return;
    }

    // TODO:
    // Verify with:
    // - Product if we have data for video author.
    // - Platform if the API can return the video duration, which is an important piece to include in the structured data on a video page. 
    // It seems videos API currently doesn't provide duration property - 
    // see: https://github.com/WeatherBug/ContentManagement/blob/master/Projects/Wb.Con.Videos.Api.Models/src/Wb.Con.Videos.Api.Models/VideoMetadata/VideoV1.cs

    const videoSchemaData = {
        'mainEntityOfPage': {
            '@type': 'WebPage',
            '@id': `https://${location.hostname}${videoData?.plid ? videoData?.plid : ''}`,
            'relatedLink': `https://${location.hostname}${videoData?.plid ? videoData?.plid : ''}`
        },
        '@context': 'https://schema.org',
        '@type': 'VideoObject',
        'name': videoData.t,
        'headline': videoData.t,
        'description': videoData.d,
        'thumbnailUrl': videoData.thumb,
        'uploadDate': videoData.putss,
        'dateModified': videoData.mutss,
        'datePublished': videoData.putss,
        'dateCreated': videoData.cutss,
        'contentUrl': videoData?.lks?.[0]?.uri ?? '',
        'keywords': videoData?.tgs?.join(',') ?? '',
        'embedUrl': `https://${location.hostname}${videoData?.plid ? videoData?.plid : ''}`,
        'publisher': {
            '@type': 'Organization',
            'name': 'WeatherBug',
            'url': 'https://www.weatherbug.com',
            'sameAs': [
                'https://www.facebook.com/WeatherBug/',
                'https://instagram.com/WeatherBug/',
                'https://www.linkedin.com/company/weatherbug',
                'https://www.pinterest.com/weatherbug/',
                'https://twitter.com/WeatherBug',
                'https://www.youtube.com/user/WeatherBugVideo',
                'https://plus.google.com/104149887451329183664'
            ],
            'logo': {
                '@type': 'ImageObject',
                'url': 'https://www.weatherbug.com/images/sharing/f1ff28ba-6f06-4745-a782-011a20397e16.png'
            }
        }
    };

    const scriptTag = document.createElement('script');
    scriptTag.type = 'application/ld+json';
    scriptTag.id = CURRENT_VIDEO_SCHEMA_JSON_LD_ID;

    scriptTag.textContent = JSON.stringify(videoSchemaData);
    document.head.appendChild(scriptTag);
}

export function removeVideoSchemaScriptTags(tagId: string): void {
    if (!tagId) {
        return;
    }
    document.getElementById(tagId)?.remove();
}